import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { registry } from 'chart.js';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfigEntityService } from 'src/app/core/services/config-entity.service';

@Component({
  selector: 'app-create-repository',
  templateUrl: './create-repository.component.html',
  styleUrl: './create-repository.component.scss'
})
export class CreateRepositoryComponent implements OnInit {
constructor(
    public dialog: MatDialogRef<CreateRepositoryComponent>,
    private configEntityService: ConfigEntityService,
    private myElement: ElementRef,
    private snackbar: MatSnackBar,
    private spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: { 
    }
  ) { }
  
  createRepositoryForm: UntypedFormGroup;
  
  ngOnInit(): void {
    this.buildAndImageAndPushForm();
  }
  
  
  buildAndImageAndPushForm() {
    this.createRepositoryForm = new UntypedFormGroup({
      name: new UntypedFormControl('', { validators: [Validators.required] }),
      registryHost: new UntypedFormControl('', { validators: [Validators.required] }),
    });
  }
  
  onCancel() {
    this.dialog.close(false);
  }
  
  toogleDialog: boolean = false;
  toogleDialogMinMax() {
    this.toogleDialog = !this.toogleDialog;
    
    const currentElement = this.myElement.nativeElement;
    
    let dialogElement = currentElement.parentElement;
    while (dialogElement && !dialogElement.classList.contains('cdk-overlay-pane')) {
      dialogElement = dialogElement.parentElement;
    }
    
    if (!dialogElement) {
      console.error('Could not find parent overlay pane');
      return;
    }
    
    
    if(this.toogleDialog) {
      dialogElement.classList.add('minimize2');
      dialogElement.classList.remove('maximize');
    } else {
      dialogElement.classList.remove('minimize2');
      dialogElement.classList.add('maximize');
      
      setTimeout(() => {
        dialogElement.classList.remove('maximize');
      }, 300);
    }
  }
  
  createRepository() {
    try {
      this.spinner.show("createRepositorySpinner");

      // Check if the form is valid
      if (!this.createRepositoryForm.valid) {
        this.createRepositoryForm.markAllAsTouched();
        this.spinner.hide("createRepositorySpinner");
        this.snackbar.open('Please fill in all required fields', 'Close', {
          duration: 5000,
          panelClass: ['error-snackbar']
        });
        return;
      }

      const formValue = this.createRepositoryForm.getRawValue();
      const request = {
        repository_name: formValue.name,
        registry_host: formValue.registryHost
      };
      this.configEntityService.createRepository(request).subscribe({
        next: (response) => {
          this.spinner.hide("createRepositorySpinner");
          let message = JSON.parse(JSON.stringify(response)).message;
          if (message) {
            this.snackbar.open(message, 'Close', {
              duration: 5000,
              panelClass: ['success-snackbar']
            });
            this.dialog.close(response);
          }
        },
        error: (error) => {
          this.spinner.hide("createRepositorySpinner");
          this.snackbar.open('Failed to create repository', 'Close', {
            duration: 5000,
            panelClass: ['error-snackbar']
          });
          console.error('Failed to create repository:', error);
        }
      });
    }
    catch (error) {
      this.spinner.hide("createRepositorySpinner");
      this.snackbar.open('Failed to create repository', 'Close', {
        duration: 5000,
        panelClass: ['error-snackbar']
      });
    }
  }
}
